import React from "react";
import Paper from "@material-ui/core/Paper";
import { withSnackbar } from "notistack";
import { bindActionCreators } from "redux";
import DefaultComp from "Component/DefaultComp/Defaultstatecomp";
import {
  CheckActionPermission,
  setPreview as setPreviewAction,
} from "Actions/commonAction";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";

import Button from "@material-ui/core/Button";
import { instance } from "Actions/AxiosInstance";
import MenuListComponent from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import PageHeader from "Component/Headers/pageHeader";
import Popover from "@material-ui/core/Popover";
import moment from "moment";
import Drawer from "@material-ui/core/Drawer";
import DrawerHeader from "Component/Headers/drawerHeader";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import {
  getFormattedImageLink,
  getFormattedDateTime,
  getFormattedDate,
  getFormattedTime,
  getFormattedTimeFromDate,
} from "Utils";
import nextArrow from "Assets/newicons/arrow/line-arrow/right/outline/line-arrow-right-outline-16px.svg";
import editIcon from "Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import logs from "Assets/newicons/finance/loan/outline/loan-outline-16px.svg";
import { ErrorMessages } from "Constants";
import { List, TDTypeConsts } from "../../../../business-configration/commons";
import emptyPage from "../../../../../../Assets/Images/undraw-wallet-aym-5.png";

class CurrencyConversion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showcurrency: null,
      selectCurrency: [],
      currencyconversionid: null,
      conversionRate: null,
      currencyAcronym: null,
      currencycode: null,
      currencyLog: [],
      currencyLogInside: [],
      logData: [],
      createmenu: false,
      create_anchorEl: null,
      disable: false,
      permissions: {
        readOnly: true,
        editable: true,
      },
      headers: [
        {
          key: "currencyacronym",
          name: "Currency",
          style: { textAlign: "center" },
          type: TDTypeConsts.OTHERS,
        },
        {
          key: "currencycode",
          name: "Symbol",
          style: { textAlign: "center" },
          type: TDTypeConsts.OTHERS,
        },
        {
          key: "conversionrate",
          name: "Conversion rate",
          style: { textAlign: "center" },
          type: TDTypeConsts.OTHERS,
        },
        {
          key: "lastupdated",
          name: "Last update",
          style: { textAlign: "center" },
          type: TDTypeConsts.OTHERS,
        },
        {
          key: "isactive",
          name: "Status",
          type: TDTypeConsts.ATIVEINACTIVE,
        },
        {
          key: "",
          name: "",
          type: TDTypeConsts.MORE_OPTIONS,
        },
      ],
    };
    this.getCurrency = this.getCurrency.bind(this);
    this.getCurrencyLog = this.getCurrencyLog.bind(this);
    this.addNewCurrency = this.addNewCurrency.bind(this);
    this.onMoreOptionClick = this.onMoreOptionClick.bind(this);
    this.editCurrency = this.editCurrency.bind(this);
    this.viewLogs = this.viewLogs.bind(this);
    this.save = this.save.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("expensecurrency");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getCurrencyLog();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getCurrencyLog() {
    const data = {
      offset: 0,
      limit: 10,
      isactive: null,
    };
    instance
      .post("subscription/getcurrencyconversion", data)
      .then((res) => {
        this.setState(
          {
            currencyLog: res.data.result,
            currencyLogInside: res.data.result[0].currencyconversion
              ? res.data.result[0].currencyconversion.map((x) => {
                  const past = moment(x.lastupdated, "YYYY-MM-DD HH:mm:ss");
                  const present = moment(new Date());
                  let diff = moment.duration(present.diff(past));
                  diff = diff.asHours();
                  let ellapsed = "";
                  if (diff < 1) {
                    ellapsed = Math.round(diff * 60);
                    ellapsed = `${ellapsed} min ago`;
                  } else if (diff > 1 && diff < 24) {
                    ellapsed = Math.round(diff);
                    ellapsed = `${ellapsed} hour ago`;
                  } else if (diff > 24) {
                    ellapsed = Math.round(diff / 24);
                    ellapsed = `${ellapsed} day ago`;
                  }
                  x.lastupdated = ellapsed;
                  return x;
                })
              : [],
          },
          () => this.getCurrency(),
        );
      })
      .catch((error) => {
        const msg =
          error && error.response && error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  }

  getCurrency() {
    instance
      .get("subscription/getcurrencycode")
      .then((res) => {
        this.setState({
          selectCurrency: res.data.result.filter(
            (x) =>
              x.currency != this.state.currencyLog[0].basecurrency &&
              (x.displayname = `${x.currency}/${x.displayname}`),
          ),
        });
      })
      .catch((error) => {
        const msg =
          error && error.response && error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  }

  addNewCurrency(name) {
    this.setState({
      drawerToggle: true,
      drawername: name,
      disable: false,
      currencyconversionid: null,
      conversionRate: null,
      currencyAcronym: null,
      currencycode: null,
    });
  }

  onMoreOptionClick(event, raw) {
    this.setState({
      createmenu: !this.state.createmenu,
      create_anchorEl: event.currentTarget,
      selectedRaw: raw,
      currencyconversionid: raw.currencyconversionid,
      conversionRate: raw.conversionrate,
      currencyAcronym: raw.currencyacronym,
      currencycode: raw.currencycode,
    });
  }

  editCurrency(name) {
    this.setState({
      drawerToggle: true,
      drawername: name,
      disable: true,
    });
  }

  viewLogs() {
    this.setState({
      drawername: "Change logs",
      drawerToggle2: true,
    });
    instance
      .get(
        `subscription/getcurrencyconversionlog/${this.state.currencyconversionid}`,
      )
      .then((res) => {
        this.setState({
          logData: res.data.result,
        });
      })
      .catch((error) => {
        const msg =
          error && error.response && error.response.data.error.message;
        this.props.enqueueSnackbar(msg, {
          variant: "error",
        });
      });
  }

  save() {
    if (this.state.currencycode === null) {
      this.props.enqueueSnackbar("Please fill in currency", {
        variant: "error",
      });
    } else if (this.state.conversionRate === null) {
      this.props.enqueueSnackbar("Please fill in conversion rate", {
        variant: "error",
      });
    } else if (this.state.conversionRate <= 0) {
      this.props.enqueueSnackbar("Expected to be greater than zero", {
        variant: "error",
      });
    } else {
      const data = {
        currencyconversionid: this.state.currencyconversionid,
        currency: null,
        currencyacronym: this.state.currencyAcronym,
        currencycode: this.state.currencycode,
        conversionrate: this.state.conversionRate,
      };
      instance
        .post("subscription/configcurrencyconversion", data)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.setState(
            {
              drawerToggle: false,
              create_anchorEl: null,
              currencyconversionid: null,
              createmenu: false,
              selectedRaw: null,
              conversionRate: null,
              currencyAcronym: null,
              currencycode: null,
            },
            () => this.getCurrencyLog(),
          );
        })
        .catch((err) => {
          this.props.enqueueSnackbar(err.response.data.error.message, {
            variant: "error",
          });
        });
    }
  }

  changeStatus(row, key, value) {
    const data = {
      currencyconversionid: row.currencyconversionid
        ? row.currencyconversionid
        : null,
      isactive: value == 1 ? true : false,
    };
    instance
      .post("subscription/activeinactivecurrencyconversion", data)
      .then((res) => {
        this.setState(
          {
            isActive: res.data.result,
          },
          () => this.getCurrencyLog(),
        );
      });
  }

  render() {
    return (
      <div>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: 35, marginTop: 24 }}>
                <PageHeader header="Currency Conversion" />
              </div>
              <div style={{ flex: 1 }}></div>
              {this.state.selectCurrency.filter(
                (cur) =>
                  this.state.currencyLogInside.findIndex(
                    (log) => log.currencycode == cur.displayvalue,
                  ) == -1,
              ).length > 0 &&
                this.state.permissions &&
                this.state.permissions.editable && (
                  <div style={{ marginRight: 31 }}>
                    <Button
                      variant="contained"
                      className="btn btn-primary-md-blue"
                      color="primary"
                      size="large"
                      onClick={() => this.addNewCurrency("Add")}
                    >
                      Add new currency
                    </Button>
                  </div>
                )}
            </div>
            <div>
              {this.state.currencyLogInside.length > 0 ? (
                <div>
                  <div className="content-outer-wrapper">
                    <div>
                      <p className="normal-dark-secondary">
                        {"Your company's base currency"}
                      </p>
                      <p className="large-text-dark">
                        {this.state.currencyLog.length != 0
                          ? `${this.state.currencyLog[0].basecurrency} (${this.state.currencyLog[0].basecurrencycode})`
                          : ""}
                      </p>
                    </div>
                    {this.state.currencyLogInside && (
                      <List
                        list={this.state.currencyLogInside}
                        headers={this.state.headers}
                        changeStatus={this.changeStatus}
                        permissions={this.state.permissions}
                        onMoreOptionClick={(event, raw) =>
                          this.onMoreOptionClick(event, raw)
                        }
                        showOnlyList={true}
                      />
                    )}
                  </div>
                </div>
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100vh",
                    }}
                  >
                    <img src={emptyPage} alt="image"></img>
                    <p className="large-text-dark">
                      There are no currencies to display
                    </p>
                    <p classNAme="normal-dark-secondary">
                      Creating currency conversions here will allow employees to
                      file expenses in those currencies.
                    </p>
                  </div>
                </div>
              )}
            </div>

            <Drawer
              anchor="right"
              open={this.state.drawerToggle}
              onClose={() =>
                this.setState({
                  drawerToggle: false,
                  create_anchorEl: null,
                  currencyConversionId: null,
                  createmenu: false,
                  selectedRaw: null,
                  conversionRate: null,
                  currencyAcronym: null,
                  currencycode: null,
                })
              }
              classes={{
                paper: "width30 padding16",
              }}
            >
              <div className="margin-top-24">
                <DrawerHeader
                  header={
                    this.state.drawername === "Add"
                      ? `Add new currency`
                      : this.state.drawername === "Edit"
                      ? `Edit Conversion rate`
                      : ""
                  }
                  closeDrawer={() =>
                    this.setState({
                      drawerToggle: false,
                      create_anchorEl: null,
                      currencyConversionId: null,
                      createmenu: false,
                      selectedRaw: null,
                      conversionRate: null,
                      currencyAcronym: null,
                      currencycode: null,
                    })
                  }
                />
                <div>
                  <div className="widht100">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: this.state.showcurrency,
                        placeholder:
                          this.state.drawername === "Add"
                            ? this.state.showcurrency
                            : this.state.currencyAcronym,
                        label: "Currency",
                        disabled: this.state.disable,
                        options:
                          this.state.currencyLogInside.length > 0
                            ? this.state.selectCurrency.filter(
                                (cur) =>
                                  this.state.currencyLogInside.findIndex(
                                    (log) =>
                                      log.currencycode == cur.displayvalue,
                                  ) == -1 &&
                                  cur.displayvalue != this.state.currencycode,
                              )
                            : this.state.selectCurrency,
                      })}
                      onChange={(value) => {
                        console.log(value);
                        this.setState({
                          currencycode: value,
                          showcurrency: `${
                            this.state.selectCurrency.find(
                              (cur) => cur.displayvalue == value,
                            ).currency
                          } / ${value}`,
                          currencyAcronym: this.state.selectCurrency.find(
                            (cur) => cur.displayvalue == value,
                          )
                            ? this.state.selectCurrency.find(
                                (cur) => cur.displayvalue == value,
                              ).currency
                            : null,
                        });
                      }}
                    />
                  </div>
                  <div className="widht100">
                    <p className="input-label">Enter conversion rate for</p>
                    <p className="input-label">
                      {this.state.currencycode
                        ? this.state.conversionRate
                          ? `Conversion rate for 1 ${this.state.currencyAcronym} = ${this.state.conversionRate} ${this.state.currencyLog[0].basecurrency}`
                          : `Conversion rate for 1 ${this.state.currencyAcronym} =`
                        : ""}
                    </p>
                    <DynamicForm
                      fields={textinputconverter({
                        value: this.state.conversionRate,
                        label: "",
                        placeholder: this.state.conversionRate,
                      })}
                      onChange={(value) =>
                        this.setState({ conversionRate: value })
                      }
                    />
                  </div>
                </div>
                <div style={{ bottom: 16, position: "fixed" }}>
                  <Button
                    variant="contained"
                    className="btn btn-primary-sm-blue"
                    color="primary"
                    size="small"
                    onClick={() => this.save("save")}
                  >
                    save
                  </Button>
                </div>
              </div>
            </Drawer>

            <Drawer
              anchor="right"
              open={this.state.drawerToggle2}
              onClose={() =>
                this.setState({ createmenu: false, drawerToggle2: false })
              }
              classes={{
                paper: "width30 padding16",
              }}
            >
              <div className="margin-top-24">
                <DrawerHeader
                  header={this.state.drawername}
                  closeDrawer={() =>
                    this.setState({ createmenu: false, drawerToggle2: false })
                  }
                />
                <div className="width100">
                  <div className="normal-dark">
                    {this.state.logData &&
                      `Conversion change logs of 1 ${this.state.currencyAcronym}`}
                  </div>
                  <div>
                    {this.state.logData &&
                      this.state.logData.map((x, index) => (
                        <div
                          style={{
                            background: "#f7f8f8",
                            marginTop: 8,
                            borderRadius: "4px",
                            height: 68,
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: 10,
                              marginRight: 10,
                            }}
                          >
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <p
                                className="normal-dark-secondary"
                                style={{ fontSize: "14px" }}
                              >
                                {this.state.logData[index + 1] &&
                                  this.state.logData[index + 1]
                                    .conversionrate}{" "}
                                {this.state.logData[index + 1] &&
                                  this.state.currencyLog.map(
                                    (y) => y.basecurrency,
                                  )}
                              </p>
                              {this.state.logData[index + 1] &&
                              this.state.logData[index + 1] ? (
                                <img
                                  src={nextArrow}
                                  alt="image"
                                  style={{
                                    height: "12px",
                                    width: "12px",
                                    marginRight: 8,
                                    marginLeft: 8,
                                  }}
                                ></img>
                              ) : (
                                ""
                              )}
                              <p style={{ margin: 0, fontSize: "16px" }}>
                                {x.conversionrate}{" "}
                                {this.state.currencyLog.map(
                                  (z) => z.basecurrency,
                                )}
                              </p>
                            </div>
                            <div style={{ flex: 1 }}></div>
                            <div>{getFormattedDate(x.lastupdated)}</div>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "flex-end",
                              marginLeft: 10,
                              marginRight: 10,
                            }}
                          >
                            <img
                              src={getFormattedImageLink(x.imagepath)}
                              alt="image"
                              style={{ height: "30px", marginBottom: 10 }}
                            ></img>
                            <div>
                              <p style={{ marginBottom: 13, marginLeft: 5 }}>
                                {x.updatedbyname}
                              </p>
                            </div>
                            <div style={{ flex: 1 }}></div>
                            <div style={{ marginBottom: 15 }}>
                              {getFormattedTimeFromDate(x.lastupdated)}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </Drawer>

            <Popover
              open={this.state.createmenu}
              anchorEl={this.state.create_anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              onClose={() => this.setState({ createmenu: false })}
              className="margin-top-8"
            >
              <Paper style={{ width: "200px" }}>
                <div>
                  <MenuListComponent>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={() => this.editCurrency("Edit")}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={editIcon}
                            alt="image"
                            style={{ marginRight: 10 }}
                          ></img>
                          Edit conversion rate
                        </span>
                      </ListItemText>
                    </ListItem>
                    <ListItem
                      className="padding-right-0 padding-top-0 padding-bottom-0 cursor-pointer"
                      onClick={() => this.viewLogs()}
                    >
                      <ListItemText style={{ padding: 0 }}>
                        <span style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={logs}
                            alt="image"
                            style={{ marginRight: 10 }}
                          ></img>
                          View change logs
                        </span>
                      </ListItemText>
                    </ListItem>
                  </MenuListComponent>
                </div>
              </Paper>
            </Popover>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles({ withTheme: true })(withSnackbar(CurrencyConversion)));
